import api from './api';
import { Owner, Patient } from '@/types';

export interface OwnerCreate {
  first_name: string;
  last_name: string;
  dni?: string;
  email?: string;
  phone?: string;
  phone_secondary?: string;
  address?: string;
  notes?: string;
}

export const ownersService = {
  async getOwners(search?: string, skip = 0, limit = 0): Promise<Owner[]> {
    const response = await api.get<Owner[]>('/owners', {
      params: { search, skip, limit },
    });
    return response.data;
  },

  async getOwner(id: number): Promise<Owner> {
    const response = await api.get<Owner>(`/owners/${id}`);
    return response.data;
  },

  async getOwnerPatients(id: number): Promise<Patient[]> {
    const response = await api.get<Patient[]>(`/owners/${id}/patients`);
    return response.data;
  },

  async createOwner(data: OwnerCreate): Promise<Owner> {
    const response = await api.post<Owner>('/owners', data);
    return response.data;
  },

  async updateOwner(id: number, data: Partial<OwnerCreate>): Promise<Owner> {
    const response = await api.put<Owner>(`/owners/${id}`, data);
    return response.data;
  },

  async deleteOwner(id: number): Promise<void> {
    await api.delete(`/owners/${id}`);
  },
};
